import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import CommonStyles from './styles';
import { AppThemeProvider } from './theme/ThemeContext';

const container = document.getElementById('root');
if (container === null) throw new Error('Root container missing in index.html');

const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <AppThemeProvider>
      <CommonStyles />
      <App />
    </AppThemeProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
